import { createShortName } from "../utils/utils";

export default ({
  icon,
  name,
  lastName,
  calendarColor,
  readOnly,
  onClick,
  small = false,
  square = false,
  showTitle = false,
}) => {
  return (
    <div
      className={`calendar-menu-calendar-view-user-edit ${
        small ? "calendar-menu-calendar-view-user-edit-small" : ""
      } ${square ? "calendar-item-square" : ""}`}
      style={{
        borderWidth: 3,
        borderColor: readOnly ? "lightgray" : calendarColor,
        borderStyle: "solid",
      }}
      title={showTitle ? name + " " + lastName : null}
      onClick={onClick}
    >
      {(icon == null || icon === "") && (
        <div className="calendar-menu-calendar-view-user-edit-text">
          {createShortName(name, lastName)}
        </div>
      )}
      {icon != null && icon !== "" && (
        <img
          className="calendar-item-user-pic"
          src={icon}
          style={{
            borderWidth: 3,
            borderColor: readOnly ? "lightgray" : calendarColor,
            borderStyle: "solid",
          }}
        />
      )}
    </div>
  );
};
